import {
  CallabilityBarrierEnum,
  CallabilityEnum,
  CapitalBaseEnum,
  CouponBarrierEnum,
  CouponEnum,
  CreditProvisionEnum,
  InvestorExerciseEnum,
  KeyDatesEnum,
  LegalEnum,
  LegalFormEnum,
  ParticipationBaseBarrierEnum,
  ParticipationBaseEnum,
  ParticipationDownsideBarrierEnum,
  ParticipationDownsideEnum,
  ParticipationEnum,
  ParticipationUpsideBarrierEnum,
  ParticipationUpsideEnum,
  PayoffEnum,
  ProductCaptureGroupsEnum,
  ProductNotesEnum,
  SalesEnum,
  ScheduleEnum,
  ScheduleType,
  SummaryEnum,
} from '../../../product-capture/model/enums/product-capture.enums';

export const PAYOFF_COUPON_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.couponType,
];
export const PAYOFF_COUPON_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.frequency,
];
export const PAYOFF_COUPON_CONVERSION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.conversionOnRedemption,
];
export const PAYOFF_COUPON_SCHEDULE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.schedule,
];
export const PAYOFF_COUPON_FIXED_RATE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.fixedRate,
];
export const PAYOFF_COUPON_FIXED_RATE_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.fixedRateType,
];
export const PAYOFF_COUPON_FIXED_RATE_STEP = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.fixedRateStep,
];
export const PAYOFF_COUPON_FIXED_PERIODS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.fixedPeriods,
];
export const PAYOFF_COUPON_FLOATING_PERIODS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.floatingPeriods,
];
export const PAYOFF_COUPON_REFERENCE_RATE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.referenceRate,
];
export const PAYOFF_COUPON_SPREAD = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.spread,
];
export const PAYOFF_COUPON_CAP = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.cap,
];
export const PAYOFF_COUPON_FLOOR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.floor,
];
export const PAYOFF_COUPON_DAY_COUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.dayCount,
];
export const PAYOFF_COUPON_BARRIER_BREAK = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrierBreak,
];
export const PAYOFF_COUPON_RANGE_ACCRUAL_RATE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.rangeAccrualRate,
];
export const PAYOFF_COUPON_COUPON_CALCULATION_DAYS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.couponCalculationDays,
];
export const PAYOFF_COUPON_RATE_RESET_SUSPENSION_LENGTH = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.rateResetSuspensionLength,
];
export const PAYOFF_COUPON_SUSPENSION_LENGTH = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.suspensionLength,
];
export const PAYOFF_COUPON_BARRIER_LOWER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.lowerLevel,
];
export const PAYOFF_COUPON_BARRIER_UPPER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.upperLevel,
];
export const PAYOFF_COUPON_BARRIER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.level,
];
export const PAYOFF_COUPON_BARRIER_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.type,
];
export const PAYOFF_COUPON_LOWER_BARRIER_STEP_SIZE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.lowerStepSize,
];
export const PAYOFF_COUPON_UPPER_BARRIER_STEP_SIZE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.upperStepSize,
];
export const PAYOFF_COUPON_BARRIER_STEP_SIZE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.stepSize,
];
export const PAYOFF_COUPON_OBVS_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.obsFrequency,
];
export const PAYOFF_COUPON_MEMORY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.memory,
];
export const PAYOFF_COUPON_TOUCH_BREAK = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.barrier,
  CouponBarrierEnum.touchAndBreak,
];
export const PAYOFF_COUPON_MULTIPLIER = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.multiplier,
];
export const PAYOFF_COUPON_RATE_RESET = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.rateReset,
];

export const PAYOFF_COUPON_RATE_INTERPOLATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.rateInterpolation,
];
export const PAYOFF_COUPON_PERFORMANCE_CALCULATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.performanceCalculation,
];
export const PAYOFF_COUPON_RESTRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.restrike,
];
export const PAYOFF_COUPON_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.strike,
];
export const PAYOFF_COUPON_LEVERAGE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.leverage,
];
export const PAYOFF_COUPON_DIGITAL_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.digitalStrike,
];
export const PAYOFF_COUPON_DIGITAL_AMOUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.digitalAmount,
];
export const PAYOFF_COUPON_CONDITIONAL_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.conditionalCouponStrike,
];
export const PAYOFF_COUPON_CONDITIONAL_RATE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
  CouponEnum.conditionalRate,
];
export const PAYOFF_COUPON = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.coupon,
];

export const PAYOFF_PARTICIPATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
];

export const PAYOFF_PARTICIPATION_UPSIDE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
];

export const PAYOFF_PARTICIPATION_UPSIDE_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.type,
];
export const PAYOFF_PARTICIPATION_UPSIDE_CALL_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.callStrike,
];
export const PAYOFF_PARTICIPATION_UPSIDE_CALL_PARTICIPATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.callParticipation,
];
export const PAYOFF_PARTICIPATION_UPSIDE_CALL_SPREAD_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.callSpreadStrike,
];
export const PAYOFF_PARTICIPATION_UPSIDE_PUT_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.putStrike,
];
export const PAYOFF_PARTICIPATION_UPSIDE_PUT_PARTICIPATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.putParticipation,
];
export const PAYOFF_PARTICIPATION_UPSIDE_PUT_SPREAD_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.putSpreadStrike,
];
export const PAYOFF_PARTICIPATION_UPSIDE_DIGITAL_AMOUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.digitalAmount,
];
export const PAYOFF_PARTICIPATION_UPSIDE_DIGITAL_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.digitalStrike,
];
export const PAYOFF_PARTICIPATION_UPSIDE_KNOCK_OUT_BARRIER = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.level,
];
export const PAYOFF_PARTICIPATION_UPSIDE_BARRIER_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.type,
];
export const PAYOFF_PARTICIPATION_UPSIDE_LOWER_BARRIER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.lowerLevel,
];
export const PAYOFF_PARTICIPATION_UPSIDE_UPPER_BARRIER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.upperLevel,
];
export const PAYOFF_PARTICIPATION_UPSIDE_OBS_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.obsFrequency,
];
export const PAYOFF_PARTICIPATION_UPSIDE_TOUCH_BREAK = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.touchAndBreak,
];

export const PAYOFF_PARTICIPATION_UPSIDE_LOWER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.lowerLevel,
];

export const PAYOFF_PARTICIPATION_UPSIDE_UPPER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.upperLevel,
];

export const PAYOFF_PARTICIPATION_UPSIDE_BARRIER_ADJUSTMENT_FACTOR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.initialBarrierAdjustmentFactor,
];

export const PAYOFF_PARTICIPATION_UPSIDE_MIN_BARRIER_ADJUSTMENT_FACTOR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.minBarrierAdjustmentFactor,
];

export const PAYOFF_PARTICIPATION_UPSIDE_MAX_BARRIER_ADJUSTMENT_FACTOR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.maxBarrierAdjustmentFactor,
];

export const PAYOFF_PARTICIPATION_UPSIDE_BARRIER_ADJUSTMENT_ROUNDING_RULE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.barrierAdjustmentRoundingRule,
];

export const PAYOFF_PARTICIPATION_UPSIDE_DIRECTION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.barrier,
  ParticipationUpsideBarrierEnum.direction,
];

export const PAYOFF_PARTICIPATION_UPSIDE_REBATE_AMOUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.rebateAmount,
];
export const PAYOFF_PARTICIPATION_UPSIDE_EARLY_TERMINATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.earlyTermination,
];
export const PAYOFF_PARTICIPATION_UPSIDE_REBATE_DATE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.rebateDate,
];
export const PAYOFF_PARTICIPATION_UPSIDE_REBATE_SETTLEMENT_LAG = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.rebateSettlementLag,
];
export const PAYOFF_PARTICIPATION_UPSIDE_MINIMUM_RETURN = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.minimumReturn,
];
export const PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_RATE_BASIS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.strikeAdjustmentRateBasis,
];
export const PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FIXED_RATE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.strikeAdjustmentFixedRate,
];
export const PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FLOATING_REFERENCE_RATE =
  [
    ProductCaptureGroupsEnum.payoff,
    PayoffEnum.participation,
    ParticipationEnum.upside,
    ParticipationUpsideEnum.strikeAdjustmentFloatingReferenceRate,
  ];
export const PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_FACTOR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.strikeAdjustmentFactor,
];
export const PAYOFF_PARTICIPATION_UPSIDE_STRIKE_ADJUSTMENT_DAY_COUNT_BASIS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.strikeAdjustmentDayCountBasis,
];
export const PAYOFF_PARTICIPATION_UPSIDE_ADJUSTMENT_DATES_CALENDAR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.adjustmentDatesScheduleCalendar,
];
export const PAYOFF_PARTICIPATION_UPSIDE_ADJUSTMENT_DATES_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.upside,
  ParticipationUpsideEnum.adjustmentDatesScheduleFrequency,
]

export const PAYOFF_PARTICIPATION_DOWNSIDE_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.downsideType,
];
export const PAYOFF_PARTICIPATION_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.strike,
];
export const PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.leverage,
];
export const PAYOFF_PARTICIPATION_DOWNSIDE_LEVERAGE_OPTIONS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.leverageOptions,
];
export const PAYOFF_PARTICIPATION_FLOOR_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.floorStrike,
];
export const PAYOFF_PARTICIPATION_KNOCK_IN_BARRIER = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.barrier,
  ParticipationDownsideBarrierEnum.level,
];
export const PAYOFF_PARTICIPATION_OBVS_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.barrier,
  ParticipationDownsideBarrierEnum.obsFrequency,
];
export const PAYOFF_PARTICIPATION_TOUCH_BREAK = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.barrier,
  ParticipationDownsideBarrierEnum.touchAndBreak,
];
export const PAYOFF_PARTICIPATION_SCHEDULE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.downside,
  ParticipationDownsideEnum.schedule,
];

export const PAYOFF_PARTICIPATION_BASE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
];

export const PAYOFF_PARTICIPATION_BASE_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.type,
];
export const PAYOFF_PARTICIPATION_BASE_LEVERAGE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.leverage,
];
export const PAYOFF_PARTICIPATION_BASE_BONUS_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.bonusStrike,
];
export const PAYOFF_PARTICIPATION_BASE_BONUS_AMOUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.bonusAmount,
];
export const PAYOFF_PARTICIPATION_BASE_CAPPED = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.capped,
];
export const PAYOFF_PARTICIPATION_BASE_GLOBAL_CAP = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.globalCap,
];
export const PAYOFF_PARTICIPATION_BASE_GLOBAL_FLOOR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.globalFloor,
];
export const PAYOFF_PARTICIPATION_BASE_INITIAL_CASH_ALLOCATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.initialCashAllocation,
];
export const PAYOFF_PARTICIPATION_BASE_INITIAL_INVESTMENT_ALLOCATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.initialInvestmentAllocation,
];
export const PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_ALLOCATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationEnum.barrier,
  ParticipationBaseBarrierEnum.investmentAllocation,
];
export const PAYOFF_PARTICIPATION_BASE_BARRIER_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.type,
];
export const PAYOFF_PARTICIPATION_BASE_BARRIER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.level,
];
export const PAYOFF_PARTICIPATION_BASE_BARRIER_LEVELS_AND_INVESTMENTS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.levelsAndInvestments,
];
export const PAYOFF_PARTICIPATION_BASE_BARRIER_INVESTMENT_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.investmentLevelFixingType,
];
export const PAYOFF_PARTICIPATION_BASE_OBS_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.obsFrequency,
];
export const PAYOFF_PARTICIPATION_BASE_DIRECTION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.direction,
];
export const PAYOFF_PARTICIPATION_BASE_TOUCH_AND_BREAK = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.barrier,
  ParticipationBaseBarrierEnum.touchAndBreak,
];
export const PAYOFF_PARTICIPATION_BASE_KNOCK_OUT_BONUS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.bonusKnockOut,
];
export const PAYOFF_PARTICIPATION_BASE_STRIKE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.strike,
];
export const PAYOFF_PARTICIPATION_BASE_ISSUE_AT_DISCOUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.issueAtDiscount,
];
export const PAYOFF_PARTICIPATION_BASE_INITIAL_LEVEL_AS_DENOMINATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.initialLevelAsDenomination,
];
export const PAYOFF_PARTICIPATION_BASE_UPPER_PARTICIPATION = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.participation,
  ParticipationEnum.base,
  ParticipationBaseEnum.upperParticipation,
];

export const PAYOFF_PARTICIPATION_CAPITAL_BASE_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.capitalBase,
  CapitalBaseEnum.capitalBaseType,
];

export const PAYOFF_PARTICIPATION_CAPITAL_BASE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.capitalBase,
];

export const PAYOFF_PARTICIPATION_CAPITAL_BASE_CAPITAL_BASE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.capitalBase,
  CapitalBaseEnum.capitalBase,
];

export const PAYOFF_CALLABILITY_CALLABILITY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
];

export const PAYOFF_CALLABILITY_CALL_EVENT_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.callEventType,
];
export const PAYOFF_CALLABILITY_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.frequency,
];

export const PAYOFF_CALLABILITY_DEFERRED_PERIODS = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.deferredPeriods,
];
export const PAYOFF_CALLABILITY_LAST_PERIOD_CALLABLE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.lastPeriodCallable,
];
export const PAYOFF_CALLABILITY_SCHEDULE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.schedule,
];
export const PAYOFF_CALLABILITY_BARRIER_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.barrier,
  CallabilityBarrierEnum.type,
];
export const PAYOFF_CALLABILITY_BARRIER_LEVEL = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.barrier,
  CallabilityBarrierEnum.level,
];
export const PAYOFF_CALLABILITY_BARRIER_STEP_SIZE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.barrier,
  CallabilityBarrierEnum.stepSize,
];
export const PAYOFF_CALLABILITY_OBS_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.barrier,
  CallabilityBarrierEnum.obsFrequency,
];
export const PAYOFF_CALLABILITY_TOUCH_BREAK = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.barrier,
  CallabilityBarrierEnum.touchAndBreak,
];
export const PAYOFF_CALLABILITY_AMOUNT_TYPE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.amountType,
];
export const PAYOFF_CALLABILITY_AMOUNT = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.amount,
];
export const PAYOFF_CALLABILITY_AMOUNT_STEP_SIZE = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.callability,
  CallabilityEnum.amountStepSize,
];

export const PAYOFF_INVESTOR_EXERCISE_FREQUENCY = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.investorExercise,
  InvestorExerciseEnum.frequency,
];

export const PAYOFF_INVESTOR_EXERCISE_SCHEDULE_CALENDAR = [
  ProductCaptureGroupsEnum.payoff,
  PayoffEnum.investorExercise,
  InvestorExerciseEnum.scheduleCalendar,
];

export const SALES_SECONDARY_MARKET_REQUIRED = [
  ProductCaptureGroupsEnum.sales,
  SalesEnum.secondaryMarketAndDataPublising,
  SalesEnum.salesSecondaryMktRequired,
];

export const SALES_SECONDARY_MARKET_QUOTE_TYPE = [
  ProductCaptureGroupsEnum.sales,
  SalesEnum.salesSecondaryMktQuotationType,
];

export const LEGAL_FORM_LEGAL_FORM_OF_OFFER_LEGAL = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.formOfOfferLegal,
];
export const LEGAL_FORM_LEGAL_LISTING_VANUE = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.listingVenue,
];
export const LEGAL_FORM_LEGAL_LISTING_STATUS = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.listingStatus,
];

export const LEGAL_FORM_LEGAL_GOVERNING_LAWS = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.governingLaws,
];

export const LEGAL_FORM_LEGAL_SECURED_ISSUANCE = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.securedIssuance,
];

export const LEGAL_FORM_LEGAL_FORM_TYPE = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.legalFormDropdown,
];
export const LEGAL_FORM_DEPOSIT_TAKER = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.depositTaker,
];
export const LEGAL_FORM_LEGAL_PROGRAMME = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.legalProgramme,
];
export const LEGAL_FORM_ISSUER_ENTITY = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.issuerEntity,
];
export const LEGAL_FORM_ISSUER_ENTITY_ID = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.issuerEntityId,
];
export const LEGAL_FORM_WRAPPER_ELIGIBILITY = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.wrapper,
];
export const LEGAL_FORM_FORM_OF_SECURITIES = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.formOfSecurities,
];
export const LEGAL_FORM_ISSUE_PRICE_LEGAL = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.issuePriceLegal,
];
export const LEGAL_FORM_ELIGIBILITY_LIABILITY_FORMAT = [
  ProductCaptureGroupsEnum.legalForm,
  LegalFormEnum.legal,
  LegalEnum.eligibleLiabilityFormat,
];

export const SUMMARY_TENOR = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.tenor,
];
export const SUMMARY_FREQUENCY = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.frequency,
];
export const SUMMARY_PERFORMANCE_TYPE = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.performanceType,
];
export const SUMMARY_SETTLEMENT_TYPE = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.settlementType,
];
export const SUMMARY_PRODUCT_TYPE = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.productType,
];
export const SUMMARY_UNDERLYING_ASSETS_GROUP = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.underlyingAssetsGroup,
];
export const SUMMARY_REFERENCE_ENTITIES = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.referenceEntitiesDisplay,
];
export const SUMMARY_SETTLEMENT_ROLL_CONVENTION = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.settlementRollConvention,
];
export const SUMMARY_ACCRUAL_ROLL_CONVENTION = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.accrualRollConvention,
];
export const SUMMARY_UNDERLYING_ASSETS = [
  ...SUMMARY_UNDERLYING_ASSETS_GROUP,
  SummaryEnum.underlyingAssets,
];
export const SUMMARY_ISSUE_DATE = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.keyDates,
  KeyDatesEnum.issueDate,
];
export const SUMMARY_REDEMPTION_DATE = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.keyDates,
  KeyDatesEnum.redemptionDate,
];
export const SUMMARY_FINAL_OBSERVATION_DATE = [
  ProductCaptureGroupsEnum.summary,
  SummaryEnum.keyDates,
  KeyDatesEnum.finalObservationDate,
];

export const CREDIT_PROVISION = [ProductCaptureGroupsEnum.creditProvision];

export const CREDIT_PROVISION_PHYSICAL_SETTLEMENT_MATRIX = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.physicalSettlementMatrix,
];

export const CREDIT_PROVISION_LOSS_AT_MATURITY = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.lossAtMaturity,
];

export const CREDIT_PROVISION_DC_DETERMINATIONS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.dcDeterminations,
];

export const CREDIT_PROVISION_EXCLUDED_OBLIGATIONS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.excludedObligations,
];

export const CREDIT_PROVISION_EXCLUDED_OBLIGATIONS_LIST = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.excludedObligationsList,
];

export const CREDIT_PROVISION_OBLIGATION_SPECIFIED_CURRENCY = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.obligationSpecifiedCurrency,
];

export const CREDIT_PROVISION_OBLIGATION_DOMESTIC_CURRENCY = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.obligationDomesticCurrency,
];

export const CREDIT_PROVISION_ALL_GUARANTEES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.allGuarantees,
];

export const CREDIT_PROVISION_CREDIT_EVENTS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.creditEvents,
];

export const CREDIT_PROVISION_CREDIT_EVENTS_GRACE_PERIOD = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.creditEventGracePeriod,
];

export const CREDIT_PROVISION_SETTLEMENT_METHOD = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.settlementMethod,
];

export const CREDIT_PROVISION_FALLBACK_SETTLEMENT_METHOD = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.fallbackSettlementMethod,
];

export const CREDIT_PROVISION_ESCROW = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.escrow,
];

export const CREDIT_PROVISION_NOTICE_OF_PUBLIC_INFO = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.noticeOfPubliclyAvailableInformation,
];

export const CREDIT_PROVISION_FINANCIAL_REFERENCE_ENTITY_TERMS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.financialReferenceEntityTerms,
];

export const CREDIT_PROVISION_SUBORDINATED_EUOPEAN_INSURANCE_TERMS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.subordinatedEuropeanInsuranceTerms,
];

export const CREDIT_PROVISION_PASS_THROUGH_SECURITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.passThroughSecurities,
];

export const CREDIT_PROVISION_ACCRUED_INTEREST = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.accruedInterest,
];

export const CREDIT_PROVISION_EXTENSION_PERIOD_INTEREST = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.extensionPeriodInterest,
];

export const CREDIT_PROVISION_UNWIND_COSTS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.unwindCosts,
];

export const CREDIT_PROVISION_NTCE_SUPPLEMENT = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.ntceSupplement,
];

export const CREDIT_PROVISION_FX_PRICE_SOURCE = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.fxPriceSource,
];

export const CREDIT_PROVISION_FIXING_RATE_TIME = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.fixingRateTime,
];

export const CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.additionalCreditBusinessCentre,
];

export const CREDIT_PROVISION_ADDITIONAL_CREDIT_BUSINESS_CENTRE_DETAILS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.additionalCreditBusinessCentreDetails,
];

export const CREDIT_PROVISION_CASH_SETTLEMENT_QUOTATION_METHOD = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.cashSettlementQuotationMethod,
];

export const CREDIT_PROVISION_CASH_SETTLEMENT_VALUATION_METHOD = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.cashSettlementValuationMethod,
];

export const CREDIT_PROVISION_FIXED_RECOVERY_AMOUNT = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.fixedRecoveryAmount,
];

export const CREDIT_PROVISION_CREDIT_EVENT_ACCRUED_COUPON_SECURITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.creditEventAccruedCouponSecurities,
];

export const CREDIT_PROVISION_CREDIT_CONTINGENT_CALL_OPTION_SECURITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.creditContingentCallOptionSecurities,
];

export const CREDIT_PROVISION_MATURITUY_CAPITAL_PROTECTED_SECURITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.maturityCapitalProtectedSecurities,
];

export const CREDIT_PROVISION_UNDERLYING_LINKED_REDEMPTION_SECURITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.underlyingLinkedRedemptionSecurities,
];

export const CREDIT_PROVISION_DETAILS_RELATING_TO_INSTALMENT_NOTES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.detailsRelatingToInstalmentNotes,
];

export const CREDIT_PROVISION_MONOLINE_INSURER = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.provisionsMonolineInsurer,
];

export const CREDIT_PROVISION_LPN = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.provisionsForLPN,
];

export const CREDIT_PROVISION_REPUBLIC_OF_HUNGARY = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.provisionsForRepublicOfHungary,
];

export const CREDIT_PROVISION_2014_SUPPLEMENT = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.supplementTo2014ISDACDD,
];

export const US_MUNICIPAL_REFERENCE_ENTITY_SUPPLEMENT = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.suppUSMunicipals,
];

export const SOVEREIGN_NO_ASSET_PACKAGE_DELIVERY_SUPPLEMENT = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.supp2014SovereignNoAssetPkgDelivery,
];

export const CREDIT_PROVISION_RUSSIAN_FEDERATION = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.provisionsForRussianFederation,
];

export const CREDIT_PROVISION_ARGENTINE_REPUBLIC = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.provisionsForArgentineRepublic,
];

export const CREDIT_PROVISION_CERTAIN_RUSSIAN_ENTITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.addnProvisionsCertainRussianEntities,
];

export const CREDIT_PROVISION_CERTAIN_VENEZUELAN_ENTITIES = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.addnProvisionsCertainVenezuelanEntities,
];

export const CREDIT_PROVISION_HELLENIC_REPUBLIC = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.addnProvisionsHellenicRepublic,
];

export const CREDIT_PROVISION_SENIOR_NON_PREFERRED_REF_OBLIGATIONS = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.seniorNonPreferredRefObligations,
];

export const CREDIT_PROVISION_SUKUK_CORPORATE = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.provisionsForSukukCorporate,
];

export const CREDIT_PROVISION_KID_WITHDRAWAL_RIGHTS_DISCLOSURE = [
  ProductCaptureGroupsEnum.creditProvision,
  CreditProvisionEnum.kidWithdrawalRightsDisclosure,
];

export const PRODUCT_NOTES = [
  ProductCaptureGroupsEnum.notesAndTasks,
  ProductNotesEnum.notes,
];

// Callability Schedule
export const EVENT_SCHEDULE_STRATEGY = [
  ProductCaptureGroupsEnum.summary,
  ScheduleEnum.schedule,
  ScheduleEnum.scheduleStrategy,
];

export const EVENT_SCHEDULE_CALL_NOTICE_LAG = [
  ProductCaptureGroupsEnum.summary,
  ScheduleEnum.schedule,
  ScheduleType.CALLABILITY,
  ScheduleEnum.callNoticeLag,
];
